/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toTalkProps, toTalkRequest } from './translator/talk'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchTalk, PostTalk, GetTalk, PutTalk, DeleteTalk } from '@/infrastructure/network/Monitaro/requests/talk'
import { ITalkProps } from '@/entities/Talk'

export default class Talk extends MonitaroGatewayBase {
  async FetchTalk(room: string, query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchTalk(room, toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.talks.map((prop) => toTalkProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async PostTalk(room: string, params: ITalkProps) {
    const { talk } = await this.apiClient.request(new PostTalk(room, toTalkRequest(params)))
    return toTalkProps(talk)
  }

  async GetTalk(room: string, id: string) {
    const { talk } = await this.apiClient.request(new GetTalk(room, id))
    return toTalkProps(talk)
  }

  async PutTalk(room: string, id: string, params: ITalkProps) {
    const { talk } = await this.apiClient.request(new PutTalk(room, id, toTalkRequest(params)))
    return toTalkProps(talk)
  }

  async DeleteTalk(room: string, id: string) {
    const { talk } = await this.apiClient.request(new DeleteTalk(room, id))
    return toTalkProps(talk)
  }
}
